import { Box, Typography, useTheme } from "@mui/material";

const IdentityFlash = ({
    identity,
    motivators,
    identityKey,
}: {
    identity: any;
    motivators: any[];
    identityKey: string;
}) => {
    const theme = useTheme();
    // @ts-expect-error
    const identityColor = theme.palette.mojoColors.identities[identityKey];

    return (
        <Box
            sx={{
                color: theme.palette.text.secondary,
                textAlign: "center",
                padding: "4px",
                width: "150px",
                margin: "auto",
                minHeight: "350px",
            }}
        >
            <img
                src={`/images/Icon${identityColor.image}.png`}
                alt={identity}
                style={{
                    maxWidth: "100%",
                    display: "block",
                }}
            />
            <Typography variant="h5">{identity}</Typography>
            {motivators.map((m, i) => (
                <Typography key={"flash" + i} variant="body1">
                    {m}
                </Typography>
            ))}
        </Box>
    );
};

export default IdentityFlash;
